module.exports = __webpack_public_path__ + "static/elegant-da3c0f31ca2bab0694df16eabb1c26fd.png";